/**
 *
 * @param publicID
 */
export function isUrl(publicID) {
  return publicID.match(/^https?:\//);
}